import { buttonClickEvent } from '@dashboard/junk-drawer/utils/eventstream';
export function modalShown(vertical) {
  return buttonClickEvent(`Lose Access Modal: ${vertical}: Shown`);
}
export function keptService(vertical) {
  return buttonClickEvent(`Lose Access Modal: ${vertical}: Keep Service`);
}
export function confirmed(vertical) {
  return buttonClickEvent(`Lose Access Modal: ${vertical}: Confirm`);
}
export function modalClosed(vertical) {
  return buttonClickEvent(`Lose Access Modal: ${vertical}: Closed`);
}